// extracted by mini-css-extract-plugin
export default {"container":"styles_container__pqILb","radio":"styles_radio__8DgRR","label":"styles_label__5hoZ+"};